<!-- vat-rate-select.component.html -->
<ng-select
        #select
        [items]="entries"
        bindLabel="name"
        [ngModel]="selectedValue"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onSelectionChange($event)"
        (blur)="onBlur()"
        [disabled]="disabled"
        [loading]="loading"
        [multiple]="false"
        [clearable]="true"
        [compareWith]="compareItems"
        [class.is-invalid]="showError">
  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.code }} [{{ item.percentage }}%] - <small>{{ item.description }}</small></div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div>[{{ item.percentage }}%] {{ item.code }} - <small>{{ item.description }}</small></div>
  </ng-template>
</ng-select>
<span *ngIf="showError">
  <small class="text-danger">{{ 'error.requiredField' | translate }}</small>
</span>